import { DialogTitle } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import type { ReactNode } from 'react';

import { useBreakpoint } from '@/src/hooks/useBreakpoint';
import { Modal, type Props as ModalProps } from '@/src/ui/Modal/Modal';

type Props = Omit<ModalProps, 'children'> & {
    title?: string;
    content: ReactNode;
};

export function ExampleModal({
    content,
    title = 'Press release example',
    onClose,
    ...props
}: Props) {
    const isBelowMd = useBreakpoint('md', 'below');

    return (
        <Modal {...props} onClose={onClose} maxWidth={1280} fullScreen={isBelowMd}>
            <VisuallyHidden>
                <DialogTitle>{title}</DialogTitle>
            </VisuallyHidden>
            {content}
        </Modal>
    );
}
